<template>
  <a-card :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'sendTime')">
              <a-range-picker v-model='queryParam.sendTime' format='YYYY-MM-DD' style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item :label="'主产品'">
              <a-select mode='multiple' v-model='queryParam.mainSids' :max-tag-count="2">
                <a-select-option v-for='item in mainAppList' :key='item.appssid' :value='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'发送渠道'">
              <a-select v-model='queryParam.remarks'>
                <a-select-option v-for='item in remarksList' :key='item.remarks' :value='item.remarks'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='12'>
          <a-col :span='6'>
            <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
            <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            <a-button type='primary' @click="downLoadData()" icon='download' style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
          </a-col>
        </a-row>
      </a-form>

      <!-- 汇总表格：绝对唯一 key，永不重复 -->
      <a-card title="汇总数据" size="small" style="margin-bottom: 16px;">
        <a-table
          :columns="summaryColumns"
          :dataSource="summaryData"
          row-key="uid"
          :pagination="false"
          :show-header="true"
          size="small"
          bordered
        />
      </a-card>

      <!-- 主表格：用 index 做 key，彻底杜绝重复 -->
      <a-table
        ref='table'
        row-key="index"
        size='middle'
        :columns='columns'
        :dataSource='dataSource.map((item,index)=>({...item,index}))'
        :pagination='false'
        :loading='loading'
        bordered
      />
      
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getSmsInfo, getSmsInfoSum, getApplistExcludingSubApp, getRemarksList } from '@/webpublicapi/order'
import moment from 'moment'
import { exportFileByPost } from '@/api/exportFile'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.'
}

export default {
  name: 'SmsChannelstatistics',
  data() {
    return {
      I18N_KEY,
      mainAppList: [],
      remarksList: [],
      sum: {},
      form: { pageNum: 1, pageSize: 10 },
      total: 0,
      dataSource: [],
      queryParam: { tradeType: null, sendTime: [], mainSids: [] },
      loading: false
    }
  },
  computed: {
    summaryColumns() {
      return [
        { title: '短信验证码-汇总', align: 'left', dataIndex: 'smsCodeTypeSum' },
        { title: '当日还款提醒-汇总', align: 'left', dataIndex: 'repaymentRemindOneSum' },
        { title: '提前一天还款提醒-汇总', align: 'left', dataIndex: 'repaymentRemindTwoSum' },
        { title: '提前两天还款提醒-汇总', align: 'left', dataIndex: 'repaymentRemindThreeSum' },
        { title: '逾期提醒-汇总', align: 'left', dataIndex: 'overdueRemindSum' },
        { title: '还款成功营销-汇总', align: 'left', dataIndex: 'repaySuccessMmSum' },
        { title: '未知交易类型-汇总', align: 'left', dataIndex: 'unkonwnTradeSum' },
        { title: '营销类短信(暂为放款失败)-汇总', align: 'left', dataIndex: 'marketingSum' },
        { title: '放款成功-汇总', align: 'left', dataIndex: 'loanSuccessSum' },
        { title: '还款成功-汇总', align: 'left', dataIndex: 'repayRemindSum' },
        { title: '催收验证码-汇总', align: 'left', dataIndex: 'collectionMmSCodeSum' },
        { title: '风控客户营销-汇总', align: 'left', dataIndex: 'riskScoreMmCodeSum' },
        { title: '还款未复贷营销-汇总', align: 'left', dataIndex: 'repayNotLoanMmCodeSum' },
        { title: '发送次数-汇总', align: 'left', dataIndex: 'sendSum' }
      ]
    },
    summaryData() {
      const data = this.sum || {}
      return [
        {
          uid: 'SUMMARY_ROW_UNIQUE_KEY', // 全局唯一
          smsCodeTypeSum: this.formatNumber(data.smsCodeType),
          repaymentRemindOneSum: this.formatNumber(data.repaymentRemindOne),
          repaymentRemindTwoSum: this.formatNumber(data.repaymentRemindTwo),
          repaymentRemindThreeSum: this.formatNumber(data.repaymentRemindThree),
          overdueRemindSum: this.formatNumber(data.overdueRemind),
          repaySuccessMmSum: this.formatNumber(data.repaySuccessMm),
          unkonwnTradeSum: this.formatNumber(data.unkonwnTrade),
          marketingSum: this.formatNumber(data.marketing),
          loanSuccessSum: this.formatNumber(data.loanSuccess),
          repayRemindSum: this.formatNumber(data.repayRemind),
          collectionMmSCodeSum: this.formatNumber(data.collectionMmSmsCode),
          riskScoreMmCodeSum: this.formatNumber(data.riskScoreMmCode),
          repayNotLoanMmCodeSum: this.formatNumber(data.repayNotLoanMmCode),
          sendSum: this.formatNumber(data.sendNum)
        }
      ]
    },
    columns() {
      return [
        { title: '盘号', align: 'left', dataIndex: 'appssid' },
        { title: '发送时间', align: 'left', dataIndex: 'sendTime' },
        { title: '发送渠道', align: 'left', dataIndex: 'remarks' },
        { title: '供应商', align: 'left', dataIndex: 'supplier' },
        { title: '短信验证码', align: 'left', dataIndex: 'smsCodeType' },
        { title: '当日还款提醒', align: 'left', dataIndex: 'repaymentRemindOne' },
        { title: '提前一天还款提醒', align: 'left', dataIndex: 'repaymentRemindTwo' },
        { title: '提前两天还款提醒', align: 'left', dataIndex: 'repaymentRemindThree' },
        { title: '逾期提醒', align: 'left', dataIndex: 'overdueRemind' },
        { title: '还款成功营销', align: 'left', dataIndex: 'repaySuccessMm' },
        { title: '未知交易类型', align: 'left', dataIndex: 'unkonwnTrade' },
        { title: '营销类短信(暂为放款失败)', align: 'left', dataIndex: 'marketing' },
        { title: '放款成功', align: 'left', dataIndex: 'loanSuccess' },
        { title: '还款成功', align: 'left', dataIndex: 'repayRemind' },
        { title: '催收验证码', align: 'left', dataIndex: 'collectionMmSmsCode' },
        { title: '风控客户营销', align: 'left', dataIndex: 'riskScoreMmCode' },
        { title: '还款未复贷营销', align: 'left', dataIndex: 'repayNotLoanMmCode' },
        { title: '发送总次数', align: 'left', dataIndex: 'sendNum' }
      ]
    }
  },
  created() {
    this.loadSelectData()
    this.loadData()
  },
  methods: {
    formatNumber(v) { return v == null ? 0 : Number(v).toLocaleString() },
    loadSelectData() {
      getApplistExcludingSubApp().then(res => res.data && (this.mainAppList = res.data))
      getRemarksList().then(res => res.data && (this.remarksList = res.data.map(s=>({remarks:s,appName:s}))))
    },
    searchQuery() { this.form.pageNum = 1; this.loadData() },
    loadData() {
      const p = this.getQueryParams()
      if (!p) return
      this.loading = true

      // 两个请求并行，等全部完成后再统一更新数据和关闭 loading
      Promise.all([
        getSmsInfo(p),
        getSmsInfoSum(p)
      ]).then(([listRes, sumRes]) => {
        if (listRes.code === 1000) {
          this.dataSource = listRes.data.rows || []
          this.total = listRes.data.total || 0
        } else {
          this.dataSource = []
          this.total = 0
          this.$message.error(listRes.msg || '查询失败')
        }

        this.sum = sumRes.code === 1000 ? sumRes.data || {} : {}
      }).catch(e => {
        this.$message.error(e.message || '请求异常')
      }).finally(() => {
        this.loading = false
      })
    },
    transformTime: t => moment(t).format('YYYY-MM-DD'),
    getQueryParams() {
      const { sendTime } = this.queryParam
      const d = {
        ...this.queryParam,
        sendStartTime: sendTime?.length ? this.transformTime(sendTime[0]) : null,
        sendEndTime: sendTime?.length ? this.transformTime(sendTime[1]) : null,
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize
      }
      delete d.sendTime
      return filterObj(d)
    },
    async downLoadData() {
      const p = this.getQueryParams()
      delete p.pageNum; delete p.pageSize
      this.loading = true
      try { await exportFileByPost('/api/web/webpublic/smsTrade/smsTradeExcel', p, '短信发送情况表.xlsx') }
      catch (e) { this.$message.error(e.message) }
      finally { this.loading = false }
    },
    handleTableChange(pn, ps) { this.form.pageNum = pn; this.form.pageSize = ps; this.loadData() },
    searchReset() {
      this.queryParam = { tradeType: null, sendTime: [], mainSids: [], remarks: undefined }
      this.form = { pageNum: 1, pageSize: 10 }
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>